import React, { useEffect, useRef } from "react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/effect-coverflow";
import useViewportActivation from "../../hooks/useViewportActivation";

const HomeTestimonial = ({ data }) => {
  const swiperRef = useRef(null);
  const swiperInstance = useRef(null);
  const [sectionRef, isNearViewport] = useViewportActivation("400px 0px");

  useEffect(() => {
    if (!isNearViewport || !swiperRef.current) return undefined;

    let active = true;

    import("swiper/bundle").then(({ default: Swiper }) => {
      if (!active || !swiperRef.current) return;
      swiperInstance.current = new Swiper(swiperRef.current, {
        grabCursor: true,
        centeredSlides: true,
        loop: true,
        navigation: {
          nextEl: ".arrow-right",
          prevEl: ".arrow-left",
        },
        keyboard: { enabled: true },
        speed: 1000,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        effect: "coverflow",
        coverflowEffect: {
          rotate: 0,
          stretch: 300,
          depth: 200,
          modifier: 1,
          slideShadows: false,
        },
        breakpoints: {
          0: { slidesPerView: 1 },
          1025: { slidesPerView: 2, spaceBetween: 30 },
        },
      });
    });

    return () => {
      active = false;
      if (swiperInstance.current) {
        swiperInstance.current.destroy(true, true);
        swiperInstance.current = null;
      }
    };
  }, [isNearViewport]);

  return (
    <section ref={sectionRef} className="location-client DM-testimonial" id="testimonials">
      <div className="container">

        <div className="row justify-content-center">
          <div className="col-md-12 col-lg-9">
            <div className="gift-content heading-center">
              <span className="subtitle">{data?.subtitle}</span>
              <h2 className="heading">{data?.title}</h2>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-12">

            <div className="swiper" ref={swiperRef}>
              <div className="swiper-wrapper">
                {data?.slides?.map((item, index) => (
                  <div className="swiper-slide" key={index}>
                    <div className="slide-inner">
                      <img src={item?.image} alt={item?.name} loading="lazy" />
                      <p dangerouslySetInnerHTML={{ __html: item?.quote }} />

                      <div className="brand-name">
                        <div className="brand-icon">
                          <div className="brand-image">
                            <img src={item?.quoteIcon} alt="Brand" />
                          </div>
                        </div>

                        <div className="brand-content">
                          <div className="title-wrap">{item?.name}</div>
                          <div className="designation-wrap">{item?.designation}</div>
                        </div>
                      </div>

                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* arrows */}
            <div className="testimonial-arrows">
              <div className="arrow arrow-left">
                <i className="fa-solid fa-arrow-left"></i>
              </div>
              <div className="arrow arrow-right">
                <i className="fa-solid fa-arrow-right"></i>
              </div>
            </div>

          </div>
        </div>

      </div>
    </section>
  );
};

export default HomeTestimonial;
